<div class="left-panel mat-elevation-z4" [ngClass]="expanded" (document:mousedown)="checkClickOutside($event.target)">
	@if (!expanded || searchActivated) {
		<section>
			<button [loader]="false" circle (click)="activateSearch(!searchActivated)" [selected]="!!expanded">
				<icon type="search" />
			</button>
		</section>
	}
	@if (!expanded || showNotifications) {
		<section>
			<button [loader]="false" circle (click)="activateNotifications(!showNotifications)" [selected]="!!expanded" [badge]="notificationsCount">
				<icon type="bell" />
			</button>
		</section>
	}
	@if (!expanded || showAgendas) {
		<section>
			<button [loader]="false" circle (click)="activateAgendas(!showAgendas)" [selected]="!!expanded" [badge]="overdueAgendasCount">
				<icon type="calendar-alt" />
			</button>
		</section>
	}
	@if (!expanded && hasAccessToScreenAuthenticator) {
		<section class="align-bottom">
			<button [loader]="false" circle (click)="activateScreenAuthenticator()" [selected]="!!expanded">
				<icon type="tv" />
			</button>
		</section>
	}
	
	<company-search [hidden]="!searchActivated" [focus]="searchActivated" (onClose)="activateSearch(false)" (onSelected)="navigateToCompany($event)" />
	<notifications [hidden]="!showNotifications" (onClose)="activateNotifications(false)" (notificationsChanged)="updateNotificationsCount($event)" />
	<agendas [hidden]="!showAgendas" (onClose)="activateAgendas(false)" (overdueAgendasChanged)="updateOverdueAgendasCount($event)" />
	@if (showScreenAuthenticator) {
		<screen-authenticator (onClose)="activateScreenAuthenticator(false)" />
	}
</div>
